/* eslint-disable */
import React, { useContext, useState, useMemo, useEffect } from 'react';
import { Row, Col, Form, Input, Checkbox, Button, Radio, Select, Spin, message } from 'antd';
import rutjs from 'rut.js';
import { rutValidator } from '../../../utils/validators';
import PepInfo from '../../HomePage/components/PepInfo';
import enrollmentAction from '../../../providers/EnrollmentContextProvider/enrollmentAction';
import { EnrollmentContext } from '../../../providers/EnrollmentContextProvider';
import tokens from '../../../utils/tokens';
import './styles.less';
import ModifyModal from './ModifyModal';
import paramType from '../../params/paramEndpoints';
import InputGeo from '../../../components/common/inputs/InputGeo';
import useParams from '../../params/useParams';
import InputRut from '../../../components/form/inputs/InputRut';
import { EnrollmentFormContext } from '../../../providers/EnrollmentFormContextProvider/index';
import DeleteButton from '../../../components/common/buttons/DeleteButton';
import { EnrollmentInstantiationContext } from '../../../providers/EnrollmentInstantiationProvider/EnrollmentInstantiationProvider';
import EnrollmentView from '../../../enums/EnrollmentView';
import EnrollmentInstantiationType from '../../../enums/EnrollmentInstantiationType';
import IdentificationType from '../../../enums/identificationType';
import select from '../../../utils/select';
import ParamSelect from '../../params/components/ParamSelect';
import StrDatePicker from '../../../components/common/inputs/StrDatePicker';
import form from '../../../utils/form';
import formUtil from '../../../utils/form';

const LegalPersonForm = () => {
  const [showModal, setShowModal] = useState(false);
  const [selectedRut, setSelectedRut] = useState([]);
  const [mainRepresentativeCount, setMainRepresentativeCount] = useState(0);

  const { enrollmentForm } = useContext(EnrollmentFormContext);
  const { dispatch } = useContext(EnrollmentContext);
  const { instantiateEnrollment, isLoading } = useContext(EnrollmentInstantiationContext);

  const [economicActivities, areEconomicActivitiesLoading] = useParams(
    paramType.ECONOMIC_ACTIVITIES
  );

  const toggleRutCheck = (key) => {
    const arr = [...selectedRut];
    arr[key] = true;
    setSelectedRut(arr);

    const formValues = enrollmentForm.getFieldsValue(true);
    Object.assign(formValues.legalRepresentatives[key], {
      identification: '',
      identificationType: IdentificationType.RUT,
    });
    enrollmentForm.setFieldsValue(formValues);
  };

  const togglePassportCheck = (key) => {
    const arr = [...selectedRut];
    arr[key] = false;
    setSelectedRut(arr);
    const formValues = enrollmentForm.getFieldsValue(true);
    Object.assign(formValues.legalRepresentatives[key], {
      identification: '',
      identificationType: IdentificationType.PASAPORTE,
    });
    enrollmentForm.setFieldsValue(formValues);

    const isFormValid = () =>
      enrollmentForm.getFieldsError().some((item) => item.errors.length > 0);
    enrollmentForm.validateFields([['legalRepresentatives', key, 'identification']]);
  };

  const [formAnt] = Form.useForm();

  const allowLettersAndWS = RegExp(
    '^(s*[a-zA-Z0-9áéíóúAÁÉÍÓÚäëïöüÄËÏÖÜ\u00f1\u00d1]*)+(s*[a-zA-Z0-9áéíóúAÁÉÍÓÚäëïöüÄËÏÖÜ\u00f1\u00d1]*)*[a-zA-Z0-9áéíóúAÁÉÍÓÚäëïöüÄËÏÖÜ\u00f1\u00d1 ]*$'
  );
  const allowNumbers = RegExp('^[0-9]+$');

  const onShowModal = () => {
    setShowModal(true);
  };

  const onCloseModal = () => {
    setShowModal(false);
  };

  const handleSubmit = () => {
    const formValues = enrollmentForm.getFieldsValue(true);

    const mainRepresentativeCount = formValues.legalRepresentatives.filter(
      (rep) => rep.isTheMainRepresentative
    ).length;

    if (mainRepresentativeCount === 0) {
      message.error('Debe seleccionar al menos un Representante Legal principal');
      return;
    }

    if (mainRepresentativeCount > 1) {
      message.error('Solo puede seleccionar un Representante Legal principal');
      return;
    }

    const instantiationPayload = {
      ...formValues,
      declaringPerson: formValues.declaringPerson
        ? {
            ...formValues.declaringPerson,
            reEmail: undefined,
            emailConf: undefined,
          }
        : undefined,
      legalPerson: {
        ...formValues.legalPerson,
        commercialAddress: {
          ...formValues.legalPerson.commercialAddress,
          streetNumber: Number(formValues.legalPerson.commercialAddress.streetNumber),
        },
        rut: rutjs.clean(formValues.legalPerson.rut),
      },
      legalRepresentatives: formValues.legalRepresentatives.map((legalRepresentative) => ({
        ...legalRepresentative,
        rut: rutjs.clean(legalRepresentative.rut),
      })),
    };

    instantiateEnrollment(
      EnrollmentInstantiationType.NewLegalPersonRut,
      instantiationPayload,
      () => dispatch({ type: enrollmentAction.GO_TO_VIEW, payload: EnrollmentView.StepsForms }),
      7200
    );
  };

  // TODO: Eliminar si hay datos precargados
  const initialValues = {
    legalRepresentatives: [{}],
  };

  const preventCopyPasteAndSpaces = (e) => {
    if (e.type === 'paste') {
      e.preventDefault();
      return;
    }

    // Prevent spaces
    const value = e.target.value;
    if (/\s/g.test(value)) {
      e.target.value = value.replace(/\s/g, '');
    }
  };

  useEffect(() => {
    enrollmentForm.setFieldsValue({ legalPerson: { hasAcceptedTerms: true } });
  }, []);

  return (
    <Spin spinning={isLoading}>
      <Row gutter={tokens.forms.horizontalGutterInPx}>
        <Col span={24}>
          <ModifyModal visible={showModal} onClose={onCloseModal} />
          <Form
            form={enrollmentForm}
            // form={formAnt}
            layout="vertical"
            onFinish={handleSubmit}
            initialValues={initialValues}
          >
            <Row justify="center">
              <Col className="companyDataForm__title" span={24}>
                Datos de la empresa
              </Col>
            </Row>
            <Row justify="center" gutter={tokens.forms.horizontalGutterInPx}>
              <Col lg={12} xs={24}>
                <Form.Item
                  label="Nombre o Razón Social"
                  name={['legalPerson', 'name']}
                  rules={[
                    {
                      required: true,
                      message: 'Nombre es requerido',
                    },
                    {
                      pattern: allowLettersAndWS,
                      message: 'Ingrese solo letras y números',
                    },
                  ]}
                >
                  <Input />
                </Form.Item>
                <Form.Item
                  name={['legalPerson', 'hasAcceptedTerms']}
                  valuePropName="checked"
                  preserve
                />
              </Col>
              <Col lg={{ span: 12 }} xs={24}>
                <Form.Item
                  label="RUT"
                  name={['legalPerson', 'rut']}
                  rules={[
                    {
                      required: true,
                      message: 'Dato requerido',
                    },
                  ]}
                >
                  <InputRut />
                </Form.Item>
              </Col>
              <Col xs={24} lg={12}>
                <Form.Item
                  label={'Fecha de formación'}
                  name={['legalPerson', 'formationDate']}
                  rules={[{ required: true, message: 'La fecha de formación es obligatoria' }]}
                >
                  <StrDatePicker
                    style={{ width: '100%' }}
                    disabledDate={form.date.dateDisablers.disabledDate}
                    format={formUtil.date.format.day}
                  />
                </Form.Item>
              </Col>
              <Col xs={24} lg={12}>
                <Form.Item
                  label={'Lugar de formación'}
                  name={['legalPerson', 'formationPlace']}
                  rules={[
                    {
                      required: true,
                      message: 'El lugar de formación es obligatorio',
                    },
                  ]}
                >
                  <Input />
                </Form.Item>
              </Col>
            </Row>
            <Row>
              <Col span={24}>
                <Form.Item
                  label="Giro Comercial"
                  name={['legalPerson', 'siiCommercialBusiness']}
                  rules={[
                    {
                      required: true,
                      message: 'Dato requerido',
                    },
                  ]}
                >
                  <Select
                    placeholder="Seleccionar"
                    loading={areEconomicActivitiesLoading}
                    disabled={areEconomicActivitiesLoading}
                    filterOption={select.filterOptions.searchByLabel}
                    showSearch
                  >
                    {economicActivities.map((activity) => (
                      <Select.Option key={activity.id} value={activity.id}>
                        {activity.name}
                      </Select.Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
              <Col lg={12}>
                <Form.Item
                  label="Tipo de Sociedad"
                  name={['legalPerson', 'societyType']}
                  rules={[
                    {
                      required: true,
                      message: 'Dato requerido',
                    },
                  ]}
                >
                  <ParamSelect paramType={paramType.SOCIETY_TYPES} />
                </Form.Item>
              </Col>
            </Row>
            <Row justify="center">
              <Col className="companyDataForm__title" span={24}>
                Domicilio Comercial
              </Col>
            </Row>
            <InputGeo
              form={enrollmentForm}
              countryName={['legalPerson', 'commercialAddress', 'country']}
              regionName={['legalPerson', 'commercialAddress', 'region']}
              cityName={['legalPerson', 'commercialAddress', 'city']}
            />
            <Row gutter={tokens.forms.horizontalGutterInPx}>
              <Col lg={{ span: 12 }} xs={24}>
                <Form.Item
                  label="Calle/Avenida"
                  name={['legalPerson', 'commercialAddress', 'streetName']}
                  rules={[
                    {
                      required: true,
                      message: 'Dato requerido',
                    },
                  ]}
                >
                  <Input autoComplete="off" />
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={tokens.forms.horizontalGutterInPx}>
              <Col lg={{ span: 6 }} xs={24}>
                <Form.Item
                  label="Número"
                  name={['legalPerson', 'commercialAddress', 'streetNumber']}
                  rules={[
                    {
                      required: true,
                      message: 'Dato requerido',
                    },
                  ]}
                >
                  <Input autoComplete="off" />
                </Form.Item>
              </Col>
              <Col lg={18} xs={24}>
                <Form.Item label="Dpto/Casa/Oficina">
                  <Row>
                    <Col lg={7} xs={24}>
                      <Form.Item name={['legalPerson', 'commercialAddress', 'houseNumber']} noStyle>
                        <Input autoComplete="off" />
                      </Form.Item>
                    </Col>
                  </Row>
                </Form.Item>
              </Col>
            </Row>
            <Row justify="center">
              <Col className="companyDataForm__title" span={24}>
                Datos del Representante Legal
              </Col>
            </Row>
            <Form.List name="legalRepresentatives">
              {(fields, { add, remove }) => (
                <>
                  {fields.map(({ key, name, fieldKey, ...restField }, index) => (
                    <>
                      <Row justify="center">
                        <Col span={24}>
                          <Form.Item
                            {...restField}
                            label="Nombre"
                            name={[name, 'name']}
                            fieldKey={[fieldKey, 'name']}
                            rules={[
                              {
                                required: true,
                                message: 'Nombre es requerido',
                              },
                              {
                                pattern: allowLettersAndWS,
                                message: 'Ingrese solo letras',
                              },
                            ]}
                          >
                            <Input autoComplete="off" />
                          </Form.Item>
                        </Col>
                      </Row>
                      <Row justify="center" gutter={tokens.forms.horizontalGutterInPx}>
                        <Col lg={12} xs={24}>
                          <Form.Item
                            {...restField}
                            label="Apellido paterno"
                            name={[name, 'firstSurname']}
                            fieldKey={[fieldKey, 'firstSurname']}
                            rules={[
                              {
                                required: true,
                                message: 'Apellido Paterno requerido',
                              },
                              {
                                pattern: allowLettersAndWS,
                                message: 'Ingrese solo letras',
                              },
                            ]}
                          >
                            <Input />
                          </Form.Item>
                        </Col>
                        <Col lg={12} xs={24}>
                          <Form.Item
                            {...restField}
                            label="Apellido materno"
                            name={[name, 'secondSurname']}
                            fieldKey={[fieldKey, 'secondSurname']}
                            rules={[
                              {
                                pattern: allowLettersAndWS,
                                message: 'Ingrese solo letras',
                              },
                            ]}
                          >
                            <Input />
                          </Form.Item>
                        </Col>
                      </Row>
                      <Row gutter={tokens.forms.horizontalGutterInPx}>
                        <Col span={24}>
                          <Form.Item
                            name={[name, 'identificationType']}
                            fieldKey={[fieldKey, 'identificationType']}
                            {...restField}
                          >
                            <Radio.Group defaultValue={1}>
                              <Radio
                                value={IdentificationType.RUT}
                                onChange={() => toggleRutCheck(key)}
                              >
                                Rut
                              </Radio>
                              <Radio
                                value={IdentificationType.PASAPORTE}
                                onChange={() => togglePassportCheck(key)}
                              >
                                Pasaporte
                              </Radio>
                              <Radio
                                value={IdentificationType.OTRO}
                                onChange={() => togglePassportCheck(key)}
                              >
                                Otro
                              </Radio>
                            </Radio.Group>
                          </Form.Item>
                        </Col>
                        <Col lg={{ span: 12 }} xs={24}>
                          <Form.Item shouldUpdate noStyle>
                            {() => (
                              <Form.Item
                                label="N° de Identificación"
                                name={[name, 'identification']}
                                fieldKey={[fieldKey, 'identification']}
                                rules={[
                                  {
                                    required: true,
                                    message: 'Identificador Requerido',
                                  },
                                  {
                                    validator: selectedRut[key] ? rutValidator : undefined,
                                    message: 'Rut invalido ',
                                  },
                                ]}
                              >
                                {selectedRut[key] ? (
                                  <InputRut />
                                ) : (
                                  <Input type="text" maxLength={12} />
                                )}
                              </Form.Item>
                            )}
                          </Form.Item>
                        </Col>
                      </Row>
                      <Row gutter={tokens.forms.horizontalGutterInPx}>
                        <Col lg={12} xs={24}>
                          <Form.Item
                            {...restField}
                            label="E-mail"
                            name={[name, 'email']}
                            fieldKey={[fieldKey, 'email']}
                            rules={[
                              {
                                required: true,
                                type: 'email',
                                message: 'email es requerido',
                              },
                            ]}
                          >
                            <Input />
                          </Form.Item>
                        </Col>
                        <Col lg={12} xs={24}>
                          <Form.Item
                            {...restField}
                            label="Reescriba su e-mail"
                            name={[name, 'confirm']}
                            dependencies={['email']}
                            fieldKey={[fieldKey, 'confirm']}
                            rules={[
                              {
                                required: true,
                                message: 'email es requerido',
                              },
                              ({ getFieldValue }) => ({
                                validator(_, value) {
                                  if (
                                    !value ||
                                    getFieldValue('legalRepresentatives')[index].email === value
                                  ) {
                                    return Promise.resolve();
                                  }
                                  return Promise.reject(
                                    new Error('Email no es igual al primero digitado')
                                  );
                                },
                              }),
                            ]}
                          >
                            <Input
                              type="email"
                              maxLength={64}
                              onPaste={preventCopyPasteAndSpaces}
                              onInput={preventCopyPasteAndSpaces}
                            />
                          </Form.Item>
                        </Col>
                      </Row>
                      <Row gutter={tokens.forms.horizontalGutterInPx}>
                        <Col lg={12} xs={24}>
                          <Form.Item
                            {...restField}
                            label="Teléfono"
                            name={[name, 'phone']}
                            fieldKey={[fieldKey, 'phone']}
                            rules={[
                              {
                                required: true,
                                message: 'Dato requerido',
                              },
                              {
                                pattern: allowNumbers,
                                message: 'Ingrese un número válido',
                              },
                            ]}
                          >
                            <Input maxLength={9} />
                          </Form.Item>
                        </Col>
                        <Col lg={12} xs={24}>
                          <Form.Item
                            {...restField}
                            label="Teléfono Fijo (opcional)"
                            name={[name, 'phoneAlt']}
                            fieldKey={[fieldKey, 'phoneAlt']}
                            rules={[
                              {
                                pattern: allowNumbers,
                                message: 'Ingrese un número válido',
                              },
                            ]}
                          >
                            <Input maxLength={9} />
                          </Form.Item>
                        </Col>
                      </Row>
                      <Row>
                        <Col xs={24}>
                          <Form.Item
                            name={[name, 'isTheMainRepresentative']}
                            valuePropName={'checked'}
                          >
                            <Checkbox
                              onChange={(e) =>
                                setMainRepresentativeCount(
                                  e.target.checked
                                    ? mainRepresentativeCount + 1
                                    : mainRepresentativeCount - 1
                                )
                              }
                            >
                              Seleccionar como Representante Legal principal
                            </Checkbox>
                          </Form.Item>
                        </Col>
                        {fields.length > 1 && (
                          <Col xs={12}>
                            <Form.Item>
                              <DeleteButton block onClick={() => remove(name)}>
                                Eliminar Rep. Legal
                              </DeleteButton>
                            </Form.Item>
                          </Col>
                        )}
                      </Row>
                    </>
                  ))}
                  <Row justify="center">
                    <Col span={24}>
                      <Button
                        className="companyDataForm__button"
                        type="dashed"
                        onClick={() =>
                          add({
                            name: '',
                            paternal: '',
                            maternal: '',
                            rut: '',
                            email: '',
                            confirm: '',
                            phone: '',
                            phoneAlt: '',
                          })
                        }
                      >
                        + Agregar otro Representante Legal
                      </Button>
                    </Col>
                  </Row>
                </>
              )}
            </Form.List>
            <Row className="companyDataForm__radio">
              <Col lg={{ span: 16 }} xs={24}>
                <Form.Item
                  label="¿Algún Representante Legal es una Persona
                Expuesta Políticamente?"
                  name={['legalPerson', 'hasAnyPepRepresentative']}
                  rules={[
                    {
                      required: true,
                      message: 'Dato requerido',
                    },
                  ]}
                >
                  <Radio.Group
                    options={[
                      { label: 'Sí', value: true },
                      { label: 'No', value: false },
                    ]}
                  />
                </Form.Item>
              </Col>
            </Row>
            <Row>
              <Col>
                <PepInfo />
              </Col>
            </Row>
            <Row className="companyDataForm__radio">
              <Col lg={{ span: 24 }} xs={24}>
                <p>
                  <span className="required">*</span>¿Algún Representante Legal es cónyuge o
                  pariente de una Persona Expuesta Políticamente hasta el segundo grado de
                  consanguinidad?
                </p>
                <Form.Item
                  name={['legalPerson', 'hasAnyPepRepresentativeRelative']}
                  rules={[
                    {
                      required: true,
                      message: 'Dato requerido',
                    },
                  ]}
                >
                  <Radio.Group
                    options={[
                      { label: 'Sí', value: true },
                      { label: 'No', value: false },
                    ]}
                  />
                </Form.Item>
              </Col>
            </Row>
            <Row>
              <Col lg={{ span: 10 }} xs={24}>
                <Button
                  className="enrollmentLegalFormContainer__button"
                  type="primary"
                  htmlType="submit"
                >
                  Continuar
                </Button>
              </Col>
            </Row>
          </Form>
        </Col>
      </Row>
    </Spin>
  );
};

export default LegalPersonForm;
